import { render } from "./ClientHome.vue?vue&type=template&id=ee5abf5a&scoped=true"
import script from "./ClientHome.vue?vue&type=script&lang=js"
export * from "./ClientHome.vue?vue&type=script&lang=js"

import "./ClientHome.vue?vue&type=style&index=0&id=ee5abf5a&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5abf5a"]])

export default __exports__